import { cookieDomodiMessageName } from './api';
import util from './utils/util';

(function () {
    class IframeCookie {
        constructor() {
            const message = this.getMessage();
            window.parent.postMessage(message, '*');
        }

        getMessage() {
            return {
                name: cookieDomodiMessageName,
                userId: util.getCookie('_dm_tr')
            };
        }
    }

    return new IframeCookie();
})();
